import React from 'react';
import PropTypes from 'prop-types';
import cssClasses from './transactionContextMenu.css';
import { ContextMenu, MenuItem } from "react-contextmenu";

const TransactionContextMenu = (props) => {
    const { id, trigger, showRuleModal, showCommentModal, isR1, isRah, isRuleFound, onToggleTransaction, showLockButton } = props;
    const addRules = trigger && trigger.row && !isR1 && !isRuleFound(trigger.row, isRah);
    const isLocked = trigger && trigger.row && trigger.row.isTransactionLocked;
    const isCoded = trigger && trigger.row && trigger.row.Coding[0];

    return <ContextMenu className={cssClasses.contextMenu} id={id}>
        {!isR1 && (addRules ? <MenuItem onClick={() => showRuleModal(trigger.row)} className={cssClasses.contextMenuItem}>
              <i className="fas fa-sm fa-flag" style={{ marginRight: 5 }} />
              Add Rule
            </MenuItem> : <MenuItem className={cssClasses.contextMenuItemDisabled} disabled>
              <i className="fas fa-sm fa-flag" style={{ marginRight: 5 }} />
              Add Rule
            </MenuItem>)}
        {<MenuItem onClick={() => showCommentModal(trigger.row)} className={cssClasses.contextMenuItem}>
            <i className="fas fa-sm fa-comment" style={{ marginRight: 5 }} />
            Add Comment
          </MenuItem>}
        {isRah && !isCoded && <MenuItem onClick={() => onToggleTransaction(trigger.row)} className={cssClasses.contextMenuItem}>
            <i className={isLocked ? 'fa fa-unlock' : 'fa fa-lock'} style={{ marginRight: 5 }} />
            {isLocked ? 'Unlock' : 'Lock'} Transaction
          </MenuItem>}
      </ContextMenu>;
}

TransactionContextMenu.propTypes = {
    id: PropTypes.string.isRequired,
    showRuleModal: PropTypes.func,
    showCommentModal: PropTypes.func,
    isRuleFound: PropTypes.func,
    isR1: PropTypes.bool,
    isRah: PropTypes.bool,
    trigger: PropTypes.shape({
        row: PropTypes.object
    })
};
export default TransactionContextMenu;


// WEBPACK FOOTER //
// ./src/components/TransactionList/TransactionContextMenu/transactionContextMenu.js